var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-container',{staticClass:"app-container",attrs:{"fluid":""}},[_c('router-view')],1),_c('px-verifier-dialog',{ref:"verifier"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }